import Keycloak from 'keycloak-js'
import { getConfig } from '../config'

const { KEYCLOAK_URL, KEYCLOAK_REALM, KEYCLOAK_CLIENT_ID } = getConfig()

const keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
})

/** True when the backend runs with AUTH_DISABLED=true (it tells us through /config.js). Local development only. */
export const authDisabled =
  getConfig().AUTH_DISABLED === true ||
  import.meta.env.VITE_AUTH_DISABLED === 'true'

let initialized = false

export async function initAuth(): Promise<void> {
  if (initialized || authDisabled) return

  const authenticated = await keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  })

  initialized = true

  if (!authenticated) {
    await keycloak.login()
  }
}

export async function getAccessToken(): Promise<string | undefined> {
  if (!initialized || !keycloak.authenticated) {
    return undefined
  }

  try {
    await keycloak.updateToken(30)
    return keycloak.token
  } catch {
    await keycloak.login()
    return undefined
  }
}

export function getUsername(): string | undefined {
  if (authDisabled) return 'dev'
  return keycloak.tokenParsed?.name as string | undefined
}

export async function logout(): Promise<void> {
  if (!initialized || authDisabled) return
  await keycloak.logout({
    redirectUri: window.location.origin,
  })
}
